import { IComponentOptions } from "angular";
import { MachineDetailProgressiveConfigurationGameInfoComponentController } from "./controller";

export const vsComponentName =
  "machineDetailProgressiveConfigurationGameInfoComponent";

export const MachineDetailProgressiveConfigurationGameInfoComponentOptions: IComponentOptions =
  {
    controller:
      MachineDetailProgressiveConfigurationGameInfoComponentController,
    controllerAs: "componentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machineConfigurationProgressiveInformation: "<",
      machineConfiguration: "<",
    },
  };
